import { render } from "./SelectVehicle.vue?vue&type=template&id=64e54776"
import script from "./SelectVehicle.vue?vue&type=script&lang=js"
export * from "./SelectVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__